document.addEventListener('DOMContentLoaded', function () {
  // 灯箱配置（可调整）
  const MAX_WIDTH = '100vw';   // 图片最大宽度
  const MAX_HEIGHT = '90vh';  // 图片最大高度

  // 创建灯箱 HTML
  const lightbox = document.createElement('div');
  lightbox.id = 'custom-lightbox';
  lightbox.innerHTML = `
    <div id="lightbox-overlay"></div>
    <div id="lightbox-container">
      <button id="lightbox-close">✕</button>
      <button id="lightbox-prev">&#8592;</button>
      <img id="lightbox-img" src="" alt="" />
      <button id="lightbox-next">&#8594;</button>
    </div>
  `;
  document.body.appendChild(lightbox);

  // 灯箱样式
  const style = document.createElement('style');
  style.textContent = `
    #custom-lightbox { display: none; position: fixed; inset: 0; z-index: 9999; }
    #lightbox-overlay { position: absolute; inset: 0; background: rgba(0,0,0,0.85); }
    #lightbox-container {
      position: absolute; top: 50%; left: 50%;
      transform: translate(-50%, -50%);
    }
    #lightbox-img {
      display: block;
      max-width: ${MAX_WIDTH};
      max-height: ${MAX_HEIGHT};
      width: auto; height: auto;
      object-fit: contain;
    }
    #lightbox-close {
      position: absolute; top: -44px; right: 0;
      background: none; border: none; color: white;
      font-size: 28px; cursor: pointer; line-height: 1;
    }
    #lightbox-prev {
      position: absolute; left: 12px; top: 50%;
      transform: translateY(-50%);
      background: rgba(0,0,0,0.35);
      border: none; color: white;
      font-size: 24px; cursor: pointer;
      padding: 10px 14px; border-radius: 4px;
      z-index: 10000;
    }
    #lightbox-next {
      position: absolute; right: 12px; top: 50%;
      transform: translateY(-50%);
      background: rgba(0,0,0,0.35);
      border: none; color: white;
      font-size: 24px; cursor: pointer;
      padding: 10px 14px; border-radius: 4px;
      z-index: 10000;
    }
    #lightbox-prev:hover, #lightbox-next:hover {
      background: rgba(0,0,0,0.6);
    }
    #custom-lightbox.active { display: block; }
  `;
  document.head.appendChild(style);

  // 获取所有缩略图
  function getThumbnails() {
    return Array.from(document.querySelectorAll('.slideshow-controls__thumbnail'));
  }

  let currentIndex = 0;

  function showImage(index) {
    const thumbs = getThumbnails();
    if (!thumbs[index]) return;
    const thumbImg = thumbs[index].querySelector('img');
    if (!thumbImg) return;

    currentIndex = index;

    let src = thumbImg.src;
    src = src.replace(/[?&]width=\d+/g, '').replace(/[?&]height=\d+/g, '');
    src = src.includes('?') ? src + '&width=2048' : src + '?width=2048';

    document.getElementById('lightbox-img').src = src;
    document.getElementById('lightbox-img').alt = thumbImg.alt;
  }

  // 点击缩略图触发灯箱
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.slideshow-controls__thumbnail');
    if (!btn) return;

    e.stopImmediatePropagation();

    const thumbs = getThumbnails();
    const index = thumbs.indexOf(btn);
    showImage(index);
    document.getElementById('custom-lightbox').classList.add('active');

  }, true);

  // 左右箭头
  document.getElementById('lightbox-prev').addEventListener('click', function (e) {
    e.stopPropagation();
    const thumbs = getThumbnails();
    showImage((currentIndex - 1 + thumbs.length) % thumbs.length);
  });

  document.getElementById('lightbox-next').addEventListener('click', function (e) {
    e.stopPropagation();
    const thumbs = getThumbnails();
    showImage((currentIndex + 1) % thumbs.length);
  });

  // 关闭灯箱
  document.getElementById('lightbox-close').addEventListener('click', closeLightbox);
  document.getElementById('lightbox-overlay').addEventListener('click', closeLightbox);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') document.getElementById('lightbox-prev').click();
    if (e.key === 'ArrowRight') document.getElementById('lightbox-next').click();
  });

  function closeLightbox() {
    document.getElementById('custom-lightbox').classList.remove('active');
  }
});
